export default function(el, dataAttribute = 'contextId') {
    if(!el || el.nodeType !== Node.ELEMENT_NODE) { return {}; }

    const contextId = el.dataset[dataAttribute];
    const contextEl = document.getElementById(contextId);
    return contextEl ? JSON.parse(contextEl.innerHTML) : {};
};
